import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Typography,
  Box,
  useTheme,
  Button,
  Dialog,
  DialogContent,
  Card,
  useMediaQuery,
} from "@mui/material";
import SecondaryCenterTemplate from "components/SecondaryCenterTemplate";
import { Field, reduxForm, getFormSyncErrors, getFormValues } from "redux-form";
import { useHistory } from "react-router-dom";
import { renderTextField } from "components/FormFields/FieldTypes";
import { Required, PhonenumberMatch } from "components/FormFields/validators";
import { phone as phoneFormatter } from "components/FormFields/formatters";
import { phone as phoneNormalizer } from "components/FormFields/normalizers";
import VerificationOTPField from "components/VerificationOTPField";
import { homeActions } from "actions";
import SuccessDialog from "components/SuccessDialog";
import MessageDialog from "pages/SearchMedication/MessageDialog";

const ChangePhoneNumber = (props) => {
  const theme = useTheme();
  const history = useHistory();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const {
    formErrors,
    formValues,
    OTPValues,
    phoneChange,
    profileInfo,
    changePhone,
    verifyPhonenumberChange,
    changePhonenumberVerify,
    accountResendInfo,
    accountResendAttempt,
    resetAccountChangeData,
  } = props;
  const { profileData } = profileInfo;

  const [showOtp, setShowOtp] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showResendSuccess, setShowResendSuccess] = useState(false);
  const [showSamePhoneDialog, setShowSamePhoneDialog] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    return () => {
      resetAccountChangeData();
    };
  }, []);

  useEffect(() => {
    if (changePhone) {
      setShowOtp(true);
    }
  }, [changePhone]);

  useEffect(() => {
    if (accountResendInfo) {
      setShowResendSuccess(true);
    }
  }, [accountResendInfo]);

  useEffect(() => {
    if (
      changePhonenumberVerify &&
      Object.keys(changePhonenumberVerify).length
    ) {
      setShowSuccess(true);
      setSuccessMsg(changePhonenumberVerify.message);
    }
  }, [changePhonenumberVerify]);

  const onOTPFormSubmit = () => {
    const verificationCode =
      OTPValues["one"] +
      OTPValues["two"] +
      OTPValues["three"] +
      OTPValues["four"] +
      OTPValues["five"] +
      OTPValues["six"];
    verifyPhonenumberChange({
      verificationCode: verificationCode,
      profileUpdateAttemptId:
        accountResendInfo && Object.keys(accountResendInfo).length
          ? accountResendInfo.data
          : changePhone,
    });
    setShowOtp(false);
  };

  const onFormSubmit = () => {
    if (formValues?.phonenumber === profileData?.data?.phone) {
      setShowSamePhoneDialog(true);
    } else {
      phoneChange(formValues.phonenumber);
    }
  };

  return (
    <SecondaryCenterTemplate pageTitle="Change Phone Number">
      <Grid container>
        <Grid item sm={8} sx={{ margin: "auto" }}>
          <form>
            <Grid item container>
              <Grid
                item
                xs={12}
                sm={12}
                p={4}
                pt={0}
                sx={{ textAlign: "center" }}
              >
                {profileData?.data && profileData?.data?.phone ? (
                  <Typography
                    variant="text4"
                    sx={{
                      color: theme.palette.common.textGrey2,
                      fontFamily: "Lato-Regular",
                    }}
                  >
                    {" "}
                    Your current phone number:
                  </Typography>
                ) : (
                  <Typography variant="h3LatoBlack">
                    {" "}
                    You have not yet added a phone number.
                  </Typography>
                )}
                <Box mt={1}>
                  <Typography variant="text2">
                    {profileData?.data &&
                      phoneFormatter(profileData?.data?.phone)}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} p={4} pt={0}>
                <Field
                  name="phonenumber"
                  isRequired
                  component={renderTextField}
                  label="Please enter your new phone number"
                  validate={[Required, PhonenumberMatch]}
                  format={phoneFormatter}
                  normalize={phoneNormalizer}
                />
              </Grid>

              <Grid item xs={12} sm={12} p={4} pt={0}>
                <Field
                  name="confirmPhonenumber"
                  isRequired
                  component={renderTextField}
                  label="Please confirm your new phone number"
                  validate={[Required, PhonenumberMatch]}
                  format={phoneFormatter}
                  normalize={phoneNormalizer}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={10}
                sx={{ margin: "auto", textAlign: "center" }}
              >
                <Box mt={4}>
                  <Button
                    variant="large"
                    onClick={() => onFormSubmit()}
                    disabled={Object.keys(formErrors).length ? true : false}
                    sx={{
                      wordSpacing: 2,
                      minWidth: "100%",
                      backgroundColor:
                        formErrors && Object.keys(formErrors).length
                          ? "#e6e6e6"
                          : undefined,
                      color:
                        formErrors && Object.keys(formErrors).length
                          ? "#637276"
                          : undefined,
                      boxShadow: "none",
                    }}
                  >
                    CHANGE PHONE NUMBER
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
          {showOtp ? (
            <Dialog open={showOtp} className="info-dialog">
              <DialogContent sx={{ padding: matchesMinWidth ? "5px" : "40px" }}>
                <Box mt={2} sx={{ paddingLeft: "8px" }}>
                  <Typography
                    variant="h3LatoRegular"
                    sx={{
                      color: theme.palette.common.textGrey2,
                      fontFamily: "Lato-Regular",
                    }}
                  >
                    A verification code has been sent to:
                  </Typography>
                </Box>
                <Box mt={1} mb={3}>
                  <Typography variant="text2">
                    {formValues && phoneFormatter(formValues.phonenumber)}
                  </Typography>
                </Box>
                <Card sx={{ height: 100 }}>
                  <Box
                    mt={2}
                    sx={{
                      textAlign: "left",
                      paddingLeft: {
                        xs: "18px",
                        sm: "18px",
                        md: "23px",
                        lg: "23px",
                        xl: "23px",
                      },
                    }}
                  >
                    <Typography
                      variant="text4"
                      sx={{
                        color: "#003d4c",
                        fontFamily: "Lato-Bold",
                        fontSize: {
                          xs: "0.8rem",
                          sm: "0.8rem",
                          md: "1rem",
                          lg: "1rem",
                        },
                      }}
                    >
                      Please enter the verification code:
                    </Typography>
                  </Box>
                  <VerificationOTPField />
                </Card>
                <Box
                  mt={2}
                  mb={5}
                  component="div"
                  sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
                  onClick={() => {
                    accountResendAttempt(changePhone);
                    // setShowResendSuccess(true);
                  }}
                >
                  <Typography
                    variant="h3LatoRegular"
                    component={Button}
                    sx={{
                      fontSize: "1rem",
                      textTransform: "none",
                      textDecoration: "underline",
                      justifyContent: "flex-start",
                      color: "#008a25",
                      minWidth: { xs: "56px", sm: "56px", md: undefined },
                    }}
                  >
                    Resend verification code{" "}
                    {showResendSuccess ? (
                      <span style={{ color: "#083d4c" }}>
                        &nbsp;-Sent&nbsp;
                      </span>
                    ) : (
                      ""
                    )}
                  </Typography>
                </Box>
                <Box mt={5} mb={3}>
                  <Button
                    variant="large"
                    disabled={
                      !OTPValues || Object.keys(OTPValues).length < 6
                        ? true
                        : false
                    }
                    onClick={onOTPFormSubmit}
                    sx={{
                      minWidth: { xs: "56px", sm: "56px", md: "100%" },
                      fontSize: {
                        xs: "14px",
                        sm: "14px",
                        md: "20px",
                        lg: "20px",
                      },
                    }}
                  >
                    CHANGE PHONE NUMBER
                  </Button>
                </Box>
                <Box mb={2}>
                  <Button
                    variant="text"
                    onClick={() => setShowOtp(false)}
                    sx={{
                      minWidth: { xs: "56px", sm: "56px", md: undefined },
                      textDecoration: "underline",
                      fontSize: {
                        xs: "14px",
                        sm: "14px",
                        md: "20px",
                        lg: "20px",
                      },
                    }}
                  >
                    CANCEL
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>
          ) : null}
          <MessageDialog showPopUp={showSamePhoneDialog}>
            <Box sx={{ maxWidth: "400px" }}>
              <Typography
                variant={matchesMinWidth ? "h3LatoBold" : "h2LatoBold"}
                sx={{ lineHeight: matchesMinWidth ? "24px" : "26px" }}
              >
                Entered value should be different from your current phone number
              </Typography>
            </Box>
            <Box mt={5}>
              <Button
                variant="large"
                onClick={() => {
                  setShowSamePhoneDialog(false);
                }}
              >
                DONE
              </Button>
            </Box>
          </MessageDialog>
          {showSuccess ? (
            <SuccessDialog
              showSuccessDialog={showSuccess}
              successMsg={successMsg}
              onSuccessClick={() => {
                setShowSuccess(false);
                history.push("/MyAccount/Profile");
              }}
            />
          ) : null}
        </Grid>
      </Grid>
    </SecondaryCenterTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    formErrors: getFormSyncErrors("CHANGE_PHONE_NUMBER_FORM")(state) || {},
    formValues: getFormValues("CHANGE_PHONE_NUMBER_FORM")(state),
    OTPValues: getFormValues("OTP_FIELD")(state),
    profileInfo: state.profile,
    changePhone: state.changePhone.data,
    accountResendInfo: state.accountResendInfo.data,
    changePhonenumberVerify: state.changePhonenumberVerify.data,
  };
};

const mapDispatchToProps = {
  getProfile: () => homeActions.getProfile(),
  phoneChange: (params) => homeActions.phoneChange(params),
  verifyPhonenumberChange: (params) =>
    homeActions.verifyPhonenumberChange(params),
  accountResendAttempt: (params) => homeActions.accountResendAttempt(params),
  resetAccountChangeData: () => homeActions.resetAccountChangeData(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "CHANGE_PHONE_NUMBER_FORM",
  })(ChangePhoneNumber)
);
